import partner_img_1 from "../../assets/images/partner/partner-1.png"
import partner_img_2 from "../../assets/images/partner/partner-2.png"
import partner_img_3 from "../../assets/images/partner/partner-3.png"
import partner_img_4 from "../../assets/images/partner/partner-4.png"
import partner_img_5 from "../../assets/images/partner/partner-5.png"

export const partnerDataOne  = [
    {
        id: 1,
        link: '/',
        src: partner_img_1
    },
    {
        id: 2,
        link: '/',
        src: partner_img_2
    },
    {
        id: 3,
        link: '/',
        src: partner_img_3
    },
    {
        id: 4,
        link: '/',
        src: partner_img_4
    },
    {
        id: 5,
        link: '/',
        src: partner_img_5
    },
    {
        id: 6,
        link: '/',
        src: partner_img_1
    },
    {
        id: 7,
        link: '/',
        src: partner_img_2
    },
    {
        id: 8,
        link: '/',
        src: partner_img_3
    },
    {
        id: 9,
        link: '/',
        src: partner_img_4
    },
    {
        id: 10,
        link: '/',
        src: partner_img_5
    },

]